const selectData = (state) => state.data;

export default selectData;
